import { jsx as m, jsxs as d } from "react/jsx-runtime";
import * as l from "react";
import { c as r } from "../clsx-OuTLNxxd.js";
import '../Stats.css';const I = "_stats_1mrwo_32", n = "_statsItem_1mrwo_41", _ = "_statsItemTitle_1mrwo_60", f = "_statsItemValue_1mrwo_73", s = {
  stats: I,
  statsItem: n,
  statsItemTitle: _,
  statsItemValue: f
}, p = l.forwardRef(({ className: t, ...a }, e) => /* @__PURE__ */ m("div", { className: r(s.stats, t), "data-cxy-name": "stats", ref: e, ...a })), u = l.forwardRef(({ "aria-label": t, className: a, title: e, value: i, ...o }, c) => /* @__PURE__ */ d(
  "div",
  {
    className: r(s.statsItem, a),
    ref: c,
    ...o,
    "aria-label": t,
    "data-testid": "stats-item",
    children: [
      /* @__PURE__ */ m("p", { "aria-hidden": !!t, className: s.statsItemValue, children: i }),
      /* @__PURE__ */ m("p", { "aria-hidden": !!t, className: s.statsItemTitle, children: e })
    ]
  }
));
p.displayName = "Stats";
u.displayName = "StatsItem";
export {
  p as Stats,
  u as StatsItem
};
